/*
  AI image disclosure, safety net for images that Liquid does not badge itself
  (rich text: product descriptions, collection custom.body, blog articles, pages, HTML metafields,
  and anything rendered later: cart, predictive search, Section Rendering API).
  Every <img> whose alt starts with "AI:" gets <span class="ab-ai-badge">, unless a badge already sits
  next to it (Liquid snippets/ab-ai-badge.liquid). Badge text: <body data-ab-ai-badge> (theme settings).
*/
(() => {
  const SEL = 'img[alt^="AI:"]';
  const DONE = 'data-ab-ai-done';
  const text = () => (document.body && document.body.dataset.abAiBadge) || 'AI';

  // A badge that is a direct child of the image's parent or of one of its 4 nearest ancestors belongs to it.
  const hasBadge = (img) => {
    let el = img;
    for (let i = 0; i < 5 && el && el !== document.body; i++) {
      const p = el.parentElement;
      if (!p) break;
      for (const c of p.children) if (c.classList && c.classList.contains('ab-ai-badge')) return true;
      el = p;
    }
    return false;
  };

  const isAlone = (img, box) => {
    for (const n of box.childNodes) {
      if (n === img) continue;
      if (n.nodeType === 3 && !n.textContent.trim()) continue;
      if (n.nodeType === 1 && n.classList.contains('ab-ai-badge')) continue;
      return false;
    }
    return true;
  };

  const badge = (img) => {
    if (img.hasAttribute(DONE) || hasBadge(img)) return;
    img.setAttribute(DONE, '');
    let host = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : img;
    let box = host.parentElement;
    if (!box) return;
    const boxCs = getComputedStyle(box);
    if (boxCs.display === 'inline' || !isAlone(host, box)) {
      // Image sits in running text (rich text): wrap it so the badge follows the image, not the paragraph.
      const wrap = document.createElement('span');
      const block = getComputedStyle(host).display === 'block';
      wrap.className = 'ab-ai-wrap ab-ai-js';
      wrap.style.cssText = 'position:relative;line-height:0;max-width:100%;display:' + (block ? 'block' : 'inline-block');
      box.insertBefore(wrap, host);
      wrap.appendChild(host);
      box = wrap;
    } else if (boxCs.position === 'static') {
      box.style.position = 'relative';
    }
    const w = img.getBoundingClientRect().width || parseInt(img.getAttribute('width'), 10) || 999;
    const s = document.createElement('span');
    s.className = 'ab-ai-badge' + (w < 100 ? ' ab-ai-badge--xs' : '');
    s.setAttribute('data-ab-ai', '');
    s.setAttribute('data-ab-ai-js', '');
    s.textContent = text();
    box.appendChild(s);
  };

  // Image swapped to a non-AI one (alt changed): drop the badge the script added.
  const cleanup = () => {
    document.querySelectorAll('[data-ab-ai-js]').forEach((s) => {
      const img = s.parentElement && s.parentElement.querySelector('img');
      if (!img || !(img.getAttribute('alt') || '').startsWith('AI:')) {
        if (img) img.removeAttribute(DONE);
        s.remove();
      }
    });
  };

  const scan = (root) => {
    cleanup();
    (root || document).querySelectorAll(SEL).forEach(badge);
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan(document);
    });
  };

  const start = () => {
    scan(document);
    new MutationObserver((list) => {
      for (const m of list) {
        if (m.type === 'attributes' || m.addedNodes.length) {
          queue();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
